export default "__VITE_ASSET__DV6Lts62__"